<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.29346 44.7065V7.25435C3.29346 6.16301 3.68272 5.22531 4.46126 4.44125C5.23976 3.65721 6.17079 3.2652 7.25436 3.2652H40.7457C41.837 3.2652 42.7747 3.65721 43.5588 4.44125C44.3428 5.22531 44.7348 6.16301 44.7348 7.25435V32.7456C44.7348 33.8292 44.3428 34.7602 43.5588 35.5387C42.7747 36.3173 41.837 36.7065 40.7457 36.7065H11.2935L3.29346 44.7065ZM9.99346 32.7456H40.7457V7.25435H7.25436V35.7847L9.99346 32.7456Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
